import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import categories from "../data/Categories.json";
import products from "../data/Products.json";
import '../Products.css'

function CategoryProducts() {
  const { id } = useParams();
  const navigate = useNavigate();

  const category = categories.find((c) => c.id === Number(id));
  const categoryProducts = products.filter(
    (p) => p.categoryId === category?.id
  );
  
    console.log(categoryProducts);

  if (!category) {
    return (
      <div className="container py-5 text-center">
        <h2>Category not found 😢</h2>
        <button className="btn btn-primary mt-3" onClick={() => navigate("/categories")}>
          Back to Categories
        </button>
      </div>
    );
  }

  return (
    <div className="container my-5">
      <h2 className="fw-bold mb-4 main-color text-center">{category.name} Products</h2>

      <div className="row">
        {categoryProducts.length > 0 ? (
          categoryProducts.map((product) => (
            <div key={product.id} className="col-lg-3 col-md-4 col-sm-6 mb-4">
              <div 
                className="card hover-card h-100 shadow-sm border-0 rounded-4"
                style={{ cursor: "pointer" }}
                onClick={() => navigate(`/product/${product.id}`)}
              >
                <img
                  src={product.image}
                  alt={product.name}
                  className="card-img-top rounded-top-4"
                  style={{ height: "180px", objectFit: "contain" }}
                />
                <div className="card-body text-center">
                  <h6 className="fw-bold main-color">{product.name}</h6>
                  <p className="text-success">${product.price}</p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-5">
            <h4>No products found in this category.</h4>
          </div>
        )}
      </div>
    </div>
  );
}

export default CategoryProducts;
